import { useState, useEffect, useRef } from 'react';
import { Tabs, Tab, Box, LinearProgress } from '@mui/material';
import { useTheme } from '@mui/material';
import MarketStatus from '../marketStatus/MarketStatus';
import ProductsList from '../productsList/ProductsList';
import { getAdminMarkets } from '../../../api/admin/adminMarketApi';
import useProtectedClient from '../../../hooks/useProtectedClient';

const TabContent = ({ marketDetails, tabIndex, isLoading}) => {
    let marketInfo = {}
    let marketId = 1
    switch (tabIndex) {
        case 0:
            marketId = 1
            break;
        case 1:
            marketId = 2
            break;
        case 2:
            marketId = 3
            break;
        case 3:
            marketId = 4
            break;
        case 4:
            marketId = 5
            break;
        case 5:
            marketId = 6
            break;
        default:
            marketId = 5
            break;
    }
    marketInfo = marketDetails.find((market) => market.marketId === marketId)
    return (
        <>
            {isLoading ?
                 <Box sx={{ width: '100%', padding: "20px" }}>
                    <LinearProgress />
                </Box> :
                <>
                    <MarketStatus marketId={marketInfo.marketId} isOpen={marketInfo?.isOpen} openingMode={marketInfo?.openingMode}/>
                    <ProductsList marketId={marketInfo.marketId} products={marketInfo.availableProducts}/>
                </>
            }
            
        </>
    );
};

const MarketSettings = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [marketsDetails, setMarketDetails] = useState([])
    const theme = useTheme();
    const protectedClient = useProtectedClient();

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };
    useEffect( () => {
        const fetchAdminMarkets = async () => {
            try {
                const res = await getAdminMarkets(protectedClient);
                setMarketDetails(res)
            } catch (err) {
                console.log("Error refreshing token: ", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAdminMarkets();
    }, []);
    
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '10px',
                margin: '12px',
                borderRadius: '12px',
                background: theme.palette.background.paper,
                boxShadow: 'none',
            }}
        >
            <Tabs
                value={selectedTab}
                onChange={handleChange}
                sx={{
                    width: '100%',
                    justifyContent: 'center',
                }}
                aria-label="tabs"
                variant="scrollable"
                scrollButtons="auto"
                centered
            >
                {["همکاران", "عاملیت‌ فروش", "کاربران", "VIP", "CIP", "پرسنل زربد"].map((label, index) => (
                    <Tab
                        key={index}
                        sx={{
                            flex: 1,
                            textAlign: 'center',
                        }}
                        label={label}
                    />
                ))}
            </Tabs>
            <TabContent marketDetails={marketsDetails} tabIndex={selectedTab} isLoading={isLoading}/>
        </Box>
    );
};

export default MarketSettings;
